export { GDButtonV2, VARIANTS } from './GDButtonV2';
